import clsx from "clsx";

/**
 * یه برند — یا با لوگو (img) یا با آیکن متنی + نام
 */
export default function BrandItem({ name, logo, icon, href }) {
  const Wrapper = href ? "a" : "div";
  const wrapperProps = href
    ? { href, target: "_blank", rel: "noreferrer noopener" }
    : {};

  return (
    <Wrapper
      {...wrapperProps}
      className={clsx(
        "group flex shrink-0 items-center gap-2.5 whitespace-nowrap px-6 sm:px-8",
        "text-[18px] font-extrabold tracking-tight sm:text-[22px]",
        "text-ink-mute transition-colors duration-300 hover:text-teal-2 dark:hover:text-teal-3"
      )}
    >
      {logo ? (
        <img
          src={logo}
          alt={name}
          loading="lazy"
          className="h-6 max-w-[90px] object-contain opacity-60 grayscale transition-all duration-300 group-hover:opacity-100 group-hover:grayscale-0 sm:h-7"
        />
      ) : (
        <span
          aria-hidden="true"
          className="text-[14px] transition-transform duration-300 group-hover:scale-110 sm:text-base"
        >
          {icon}
        </span>
      )}
      <span>{name}</span>
    </Wrapper>
  );
}